import { BackIcon } from '@assets/icons';
import { Button, IconButton } from '@components/button';
import { Checkbox } from '@components/form';
import { Group } from '@components/layout';
import { Typography } from '@components/typography';
import { ExactComparator } from '@generated/graphql';
import { Divider, MenuItem, Stack } from '@mui/material';
import { useState } from 'react';
import { FilterComponent } from './types';

export const MultiSelectFilter: FilterComponent<ExactComparator[] | string[]> = ({
  title,
  filter,
  details,
  onApply,
  onBack,
}) => {
  if (filter.type !== 'exact' && filter.type !== 'string') {
    throw new Error('MultiSelectFilter does not support this filter type');
  }

  const [dirtySelected, setDirtySelected] = useState<string[]>(
    filter.type === 'string'
      ? (filter.value as string[])
      : (filter.value as { eq: string }[]).map((item) => item.eq),
  );

  return (
    <Stack maxHeight="500px">
      <Group alignItems="center" gap={1} sx={{ px: 2 }}>
        <IconButton size={16} onClick={onBack} Icon={BackIcon} />
        <Typography variant="body2">{title}</Typography>
      </Group>
      <Divider sx={{ m: 2 }} flexItem />
      <Stack sx={{ overflowY: 'auto' }}>
        {details?.map((option) => (
          <MenuItem
            key={option.value}
            sx={{ gap: 2 }}
            onClick={() => {
              setDirtySelected((prev) =>
                prev.includes(option.value)
                  ? prev.filter((item) => item !== option.value)
                  : [...prev, option.value],
              );
            }}
          >
            <Checkbox checked={dirtySelected?.includes(option.value)} sx={{ height: 'auto' }} />
            {option.display}
          </MenuItem>
        ))}
      </Stack>
      <Divider sx={{ m: 2 }} flexItem />
      <Group justifyContent="flex-end" sx={{ px: 2, gap: 2 }}>
        <Button size="small" variant="secondary" onClick={() => setDirtySelected([])}>
          Clear all
        </Button>
        <Button
          size="small"
          variant="primary"
          onClick={() => {
            onApply({
              value:
                filter.type === 'string'
                  ? dirtySelected
                  : dirtySelected.map((dirtyValue) => ({ eq: dirtyValue })),
              display: dirtySelected.map(
                (dirtyValue) =>
                  details.find((option) => option.value === dirtyValue)?.display || dirtyValue,
              ),
            });
          }}
        >
          Apply
        </Button>
      </Group>
    </Stack>
  );
};
